var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-manager',{attrs:{"canEdit":false,"canDelete":true,"context":'kiosk-all',"functionalRoles":_vm.functionalRoles,"toolbarColor":_vm.appColor_Abby,"toolbarColorDark":_vm.appColor_AbbyDark}})}
var staticRenderFns = []

export { render, staticRenderFns }